// MATERIAL
import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const PageContainer = styled(Stack)(({ theme }) => ({
  paddingTop: 30,
  paddingBottom: 30,
}));
